import React from 'react';
import { Box, Typography, Container, Grid } from '@mui/material';
import Fade from 'react-reveal/Fade';
import { CDN } from '../api';

const cards = [
  {
    title: 'What We Do',
    image: `${CDN}/houses/house4/drone.jpeg`,
    body: 'Emerich Custom Build specializes in crafting high-end, bespoke homes tailored to the unique preferences of discerning clients. Our commitment to excellence ensures each home reflects the individuality and lifestyle of its owner.',
  },
  {
    title: 'Where We Build',
    image: `${CDN}/site/map.jpg`,
    body: 'Based in the Lawrenceville area, we extend our expertise throughout Gwinnett County — blending local charm with individual client vision to create exceptional homes in thriving communities.',
  },
  {
    title: 'Who We Are',
    image: `${CDN}/site/stef.jpg`,
    body: "Led by founder Stefan, we are driven by a passion for building homes of unparalleled quality. Stefan's dedication to craftsmanship shapes every project we take on, from foundation to final finish.",
  },
];

function Hero() {
  return (
    <Box sx={{ backgroundColor: '#0d0d0d', py: { xs: 8, md: 12 } }}>
      <Container maxWidth="lg">
        <Fade bottom>
          <Box textAlign="center" mb={8}>
            <Typography
              variant="overline"
              sx={{ color: '#FFA13C', letterSpacing: '0.2em', fontWeight: 600 }}
            >
              About Us
            </Typography>
            <Typography
              variant="h3"
              sx={{
                color: '#f0f0f0',
                fontWeight: 700,
                mt: 1,
                fontSize: { xs: '1.8rem', md: '2.5rem' },
              }}
            >
              Built on Passion. Defined by Craft.
            </Typography>
          </Box>
        </Fade>

        <Grid container spacing={4}>
          {cards.map((card, i) => (
            <Grid item xs={12} md={4} key={i}>
              <Fade bottom delay={i * 120}>
                <Box
                  sx={{
                    backgroundColor: '#161616',
                    border: '1px solid #2a2a2a',
                    borderRadius: 3,
                    overflow: 'hidden',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      height: 240,
                      overflow: 'hidden',
                    }}
                  >
                    <Box
                      component="img"
                      src={card.image}
                      alt={card.title}
                      sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: i === 2 ? 'center 15%' : 'center',
                        display: 'block',
                        transition: 'transform 0.4s ease',
                        '&:hover': { transform: 'scale(1.04)' },
                      }}
                    />
                  </Box>
                  <Box sx={{ p: 3, flexGrow: 1 }}>
                    <Box
                      sx={{
                        width: 32,
                        height: 3,
                        backgroundColor: '#FFA13C',
                        mb: 2,
                        borderRadius: 1,
                      }}
                    />
                    <Typography
                      variant="h6"
                      sx={{ color: '#f0f0f0', fontWeight: 700, mb: 1.5 }}
                    >
                      {card.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: '#999', lineHeight: 1.8 }}
                    >
                      {card.body}
                    </Typography>
                  </Box>
                </Box>
              </Fade>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default Hero;
